import React, { Component } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import axios from 'axios'
import ReactTable from 'react-table'
import { API_URL } from '../constants'
import { PageWrapper, Header } from '../components'
import { Link } from 'react-router-dom'
import 'react-table/react-table.css'
import { isEmpty, get } from 'lodash'

const GlobalStyle = createGlobalStyle`
  body>div{
    max-width:100% !important;
  }
`

const TableWrap = styled.div`
  position: relative;
  .ReactTable.-striped.-highlight {
    padding-bottom: 50px;
  }
  .rt-thead.-header {
    background: #078489;
    color: #fff;
  }
  .rt-td {
    white-space: normal !important;
  }
  .pagination-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #078489;
    color: #fff;
  }
  .ReactTable .-pagination .-btn[disabled] {
    color: #fff;
    opacity: 0.9;
  }
  .ReactTable .-pagination .-btn {
    color: #fff;
  }
  .rt-tbody {
    /* max-height: calc(100vh - 93px); */
  }
`
class RewardOption extends Component {
  state = { loader: false, rewardOptionData: [] }
  componentDidMount() {
    this.getUserReceipt()
  }

  getUserReceipt = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/RewardOptions`)
      this.setState({ rewardOptionData: data })
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    const { rewardOptionData } = this.state
    return (
      <React.Fragment>
        <GlobalStyle />
        <Header
          icon="arrowBack"
          title="Reward Option"
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          style={{ minWidth: '100%' }}
          color="#fff"
        />
        <PageWrapper viewPadding="0 20px" height="auto" modifyPadding="0 20px" style={{ marginTop: 60 }}>
          <TableWrap>
            <ReactTable
              data={rewardOptionData}
              columns={[
                {
                  Header: 'ID',
                  accessor: 'id',
                  width: 50
                },
                {
                  Header: 'Title',
                  accessor: 'rewardName',
                  width: 150
                },
                {
                  Header: 'Description',
                  accessor: 'rewardDescription',
                  width: 300
                },
                {
                  Header: 'Points',
                  accessor: 'rewardPoints',
                  width: 70
                },
                {
                  Header: 'Value',
                  accessor: 'rewardValue',
                  width: 70
                },
                {
                  Header: 'Quantity',
                  accessor: 'quantity',
                  width: 70
                },
                {
                  Header: 'Type',
                  accessor: 'rewardType',
                  width: 100
                },
                {
                  Header: 'Services Areas',
                  accessor: 'rewardServiceAreas',
                  Cell: row =>
                    !isEmpty(get(row.original, 'rewardServiceAreas', null))
                      ? get(row.original, 'rewardServiceAreas', '')
                          .split('|')
                          .map(item => item)
                          .join(',')
                      : get(row.original, 'rewardServiceAreas', null),
                  width: 400
                },
                {
                  Header: 'Partner Name',
                  accessor: 'rewardPartnerName',
                  width: 200
                },
                {
                  Header: 'About',
                  accessor: 'rewardPartnerDescription',
                  width: 400
                },
                {
                  Header: 'Partner Addresses',
                  accessor: 'rewardPartnerAddresses',
                  width: 250
                },
                {
                  Header: 'Image',
                  accessor: 'rewardImages',
                  Cell: row =>
                    isEmpty(get(row.original, 'rewardImages', '')) ? (
                      <img src={require('../static/images/no-image.png')} height="100px" alt={'demo'} />
                    ) : (
                      JSON.parse(get(row.original, 'rewardImages', '[]')).map(item => (
                        <img src={item} height="70px" width="100px" alt={item} />
                      ))
                    ),
                  height: 100,
                  width: 150
                },
                {
                  Header: 'Partner Logo',
                  accessor: 'rewardPartnerLogo',
                  Cell: row =>
                    isEmpty(get(row.original, 'rewardPartnerLogo', '')) ? (
                      <img src={require('../static/images/no-image.png')} height="100px" alt={'demo'} />
                    ) : (
                      <img src={get(row.original, 'rewardPartnerLogo', '')} height="70px" width="100px" />
                    ),
                  height: 100,
                  width: 150
                },
                {
                  Header: 'Action',
                  Cell: row => (
                    <React.Fragment>
                      <Link to={`/view-user-redemption-native/${get(row.original, 'id', '')}`}>View Redemptions</Link>{' '}
                    </React.Fragment>
                  ),
                  width: 150
                }
              ]}
              defaultPageSize={50}
              // pageSize={5}
              minRows={0}
              resizable={false}
              className="-striped -highlight"
            />
          </TableWrap>
        </PageWrapper>
      </React.Fragment>
    )
  }
}
export default RewardOption



// WEBPACK FOOTER //
// ./src/pages/RewardOption.js